import { GROUP_COLUMN_NAME, TABLE_CONFIG } from '../../stores/ksnmTableStore/ksnmTableStore';

export const useSetGroupColumnWidth = (tableName: string): void => {
  const lsData = localStorage.getItem(TABLE_CONFIG);
  const config = lsData ? JSON.parse(lsData) : {};

  if (config?.[tableName]) {
    if (!config[tableName].widthColumn || !config[tableName].widthColumn[GROUP_COLUMN_NAME]) {
      localStorage.setItem(
        TABLE_CONFIG,
        JSON.stringify({
          ...config,
          [tableName]: {
            ...config[tableName],
            widthColumn: { ...(config[tableName].widthColumn ?? {}), [GROUP_COLUMN_NAME]: 405 },
          },
        }),
      );
    }
  }
};
